
import { useEffect, useState } from 'react'
import { Boxes, Layers, Package } from 'lucide-react'
import Style from './style.module.css'
// import AddItemForm from '../items/add-popup'
import { useApiCall } from '../../../component/custom-hooks/api-call'
import AddVendorPopup from '../vendor/add-popup'
import LeftSidePopupLayout from '../../../component/popup/modal-layout'
// import AddVariantForm from '../variants/add-popup'

const ElectricityConfigPopup = ({ onClose = () => { }, onError = () => { }, onSuccess = () => { }, onSubmit = () => { }, currentData, tabIndex = null }) => {
    const apiCall = useApiCall();
    const [navIndex, setNavIndex] = useState(tabIndex || 0);
    const handleNavClick = (index) => {setNavIndex(index);};    

    const navItems = [
        { label: "Vendors", icon: <Layers size="1.2em" /> },
        // { label: "Items", icon: <Package size="1.2em" /> },
        // { label: "Variants", icon: <Boxes size="1.2em" /> },
    ];

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <div className={Style.modal_header}>
                        <div className={Style.modal_nav}>
                            <ul>
                                {navItems.map((item, i) => {
                                    return (
                                        <li
                                            key={i}
                                            className={`${navIndex === i ? Style.active : ""} ${tabIndex !== null ? navIndex === i ? "" : Style.disabled : ""}`}
                                            onClick={() => {
                                                if (tabIndex !== null) {
                                                    if (!navIndex === i) {
                                                        handleNavClick(i);
                                                    }
                                                } else {
                                                    handleNavClick(i);
                                                }
                                            }}
                                        >
                                            <div className={Style.icon}>{item.icon}</div>
                                            <span>{item.label}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>

                    {
                        navIndex === 0 && (
                            <AddVendorPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                Style={Style}
                            />
                        )
                    }
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default ElectricityConfigPopup;